import {
  GET_BOOKING,
  UPDATE_BOOKING,
} from './../../mutation-types';

export default {
  [GET_BOOKING](state, booking) {
    state.email = booking.email;
    state.first_name = booking.first_name;
    state.last_name = booking.last_name;
  },
  [UPDATE_BOOKING](state, booking) {
    state.email = booking.email;
    state.first_name = booking.first_name;
    state.last_name = booking.last_name;
  },
};



// WEBPACK FOOTER //
// ./src/app/store/modules/booking/mutations.js